function uuidv4() {
  return window.crypto.randomUUID()
}

export { uuidv4 }
